import Se, { useState as dr, useRef as vr, useEffect as _e } from "react";
var Q = { exports: {} }, I = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var je;
function hr() {
  if (je) return I;
  je = 1;
  var g = Se, v = Symbol.for("react.element"), w = Symbol.for("react.fragment"), u = Object.prototype.hasOwnProperty, x = g.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, T = { key: !0, ref: !0, __self: !0, __source: !0 };
  function j(E, d, b) {
    var y, _ = {}, S = null, L = null;
    b !== void 0 && (S = "" + b), d.key !== void 0 && (S = "" + d.key), d.ref !== void 0 && (L = d.ref);
    for (y in d) u.call(d, y) && !T.hasOwnProperty(y) && (_[y] = d[y]);
    if (E && E.defaultProps) for (y in d = E.defaultProps, d) _[y] === void 0 && (_[y] = d[y]);
    return { $$typeof: v, type: E, key: S, ref: L, props: _, _owner: x.current };
  }
  return I.Fragment = w, I.jsx = j, I.jsxs = j, I;
}
var $ = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Te;
function pr() {
  return Te || (Te = 1, process.env.NODE_ENV !== "production" && function() {
    var g = Se, v = Symbol.for("react.element"), w = Symbol.for("react.portal"), u = Symbol.for("react.fragment"), x = Symbol.for("react.strict_mode"), T = Symbol.for("react.profiler"), j = Symbol.for("react.provider"), E = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), b = Symbol.for("react.suspense"), y = Symbol.for("react.suspense_list"), _ = Symbol.for("react.memo"), S = Symbol.for("react.lazy"), L = Symbol.for("react.offscreen"), ee = Symbol.iterator, Oe = "@@iterator";
    function Pe(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = ee && e[ee] || e[Oe];
      return typeof r == "function" ? r : null;
    }
    var k = g.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function h(e) {
      {
        for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
          t[n - 1] = arguments[n];
        ke("error", e, t);
      }
    }
    function ke(e, r, t) {
      {
        var n = k.ReactDebugCurrentFrame, o = n.getStackAddendum();
        o !== "" && (r += "%s", t = t.concat([o]));
        var l = t.map(function(s) {
          return String(s);
        });
        l.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, l);
      }
    }
    var De = !1, Ne = !1, Ae = !1, Fe = !1, Me = !1, re;
    re = Symbol.for("react.module.reference");
    function Ie(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === u || e === T || Me || e === x || e === b || e === y || Fe || e === L || De || Ne || Ae || typeof e == "object" && e !== null && (e.$$typeof === S || e.$$typeof === _ || e.$$typeof === j || e.$$typeof === E || e.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === re || e.getModuleId !== void 0));
    }
    function $e(e, r, t) {
      var n = e.displayName;
      if (n)
        return n;
      var o = r.displayName || r.name || "";
      return o !== "" ? t + "(" + o + ")" : t;
    }
    function te(e) {
      return e.displayName || "Context";
    }
    function R(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && h("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case u:
          return "Fragment";
        case w:
          return "Portal";
        case T:
          return "Profiler";
        case x:
          return "StrictMode";
        case b:
          return "Suspense";
        case y:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case E:
            var r = e;
            return te(r) + ".Consumer";
          case j:
            var t = e;
            return te(t._context) + ".Provider";
          case d:
            return $e(e, e.render, "ForwardRef");
          case _:
            var n = e.displayName || null;
            return n !== null ? n : R(e.type) || "Memo";
          case S: {
            var o = e, l = o._payload, s = o._init;
            try {
              return R(s(l));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var O = Object.assign, A = 0, ne, ae, ie, se, oe, le, ue;
    function ce() {
    }
    ce.__reactDisabledLog = !0;
    function Le() {
      {
        if (A === 0) {
          ne = console.log, ae = console.info, ie = console.warn, se = console.error, oe = console.group, le = console.groupCollapsed, ue = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: ce,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        A++;
      }
    }
    function We() {
      {
        if (A--, A === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: O({}, e, {
              value: ne
            }),
            info: O({}, e, {
              value: ae
            }),
            warn: O({}, e, {
              value: ie
            }),
            error: O({}, e, {
              value: se
            }),
            group: O({}, e, {
              value: oe
            }),
            groupCollapsed: O({}, e, {
              value: le
            }),
            groupEnd: O({}, e, {
              value: ue
            })
          });
        }
        A < 0 && h("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var B = k.ReactCurrentDispatcher, Z;
    function W(e, r, t) {
      {
        if (Z === void 0)
          try {
            throw Error();
          } catch (o) {
            var n = o.stack.trim().match(/\n( *(at )?)/);
            Z = n && n[1] || "";
          }
        return `
` + Z + e;
      }
    }
    var H = !1, V;
    {
      var Ve = typeof WeakMap == "function" ? WeakMap : Map;
      V = new Ve();
    }
    function fe(e, r) {
      if (!e || H)
        return "";
      {
        var t = V.get(e);
        if (t !== void 0)
          return t;
      }
      var n;
      H = !0;
      var o = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var l;
      l = B.current, B.current = null, Le();
      try {
        if (r) {
          var s = function() {
            throw Error();
          };
          if (Object.defineProperty(s.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(s, []);
            } catch (m) {
              n = m;
            }
            Reflect.construct(e, [], s);
          } else {
            try {
              s.call();
            } catch (m) {
              n = m;
            }
            e.call(s.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (m) {
            n = m;
          }
          e();
        }
      } catch (m) {
        if (m && n && typeof m.stack == "string") {
          for (var i = m.stack.split(`
`), p = n.stack.split(`
`), c = i.length - 1, f = p.length - 1; c >= 1 && f >= 0 && i[c] !== p[f]; )
            f--;
          for (; c >= 1 && f >= 0; c--, f--)
            if (i[c] !== p[f]) {
              if (c !== 1 || f !== 1)
                do
                  if (c--, f--, f < 0 || i[c] !== p[f]) {
                    var C = `
` + i[c].replace(" at new ", " at ");
                    return e.displayName && C.includes("<anonymous>") && (C = C.replace("<anonymous>", e.displayName)), typeof e == "function" && V.set(e, C), C;
                  }
                while (c >= 1 && f >= 0);
              break;
            }
        }
      } finally {
        H = !1, B.current = l, We(), Error.prepareStackTrace = o;
      }
      var N = e ? e.displayName || e.name : "", P = N ? W(N) : "";
      return typeof e == "function" && V.set(e, P), P;
    }
    function Ye(e, r, t) {
      return fe(e, !1);
    }
    function Ue(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function Y(e, r, t) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return fe(e, Ue(e));
      if (typeof e == "string")
        return W(e);
      switch (e) {
        case b:
          return W("Suspense");
        case y:
          return W("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case d:
            return Ye(e.render);
          case _:
            return Y(e.type, r, t);
          case S: {
            var n = e, o = n._payload, l = n._init;
            try {
              return Y(l(o), r, t);
            } catch {
            }
          }
        }
      return "";
    }
    var F = Object.prototype.hasOwnProperty, de = {}, ve = k.ReactDebugCurrentFrame;
    function U(e) {
      if (e) {
        var r = e._owner, t = Y(e.type, e._source, r ? r.type : null);
        ve.setExtraStackFrame(t);
      } else
        ve.setExtraStackFrame(null);
    }
    function Be(e, r, t, n, o) {
      {
        var l = Function.call.bind(F);
        for (var s in e)
          if (l(e, s)) {
            var i = void 0;
            try {
              if (typeof e[s] != "function") {
                var p = Error((n || "React class") + ": " + t + " type `" + s + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[s] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw p.name = "Invariant Violation", p;
              }
              i = e[s](r, s, n, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (c) {
              i = c;
            }
            i && !(i instanceof Error) && (U(o), h("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", n || "React class", t, s, typeof i), U(null)), i instanceof Error && !(i.message in de) && (de[i.message] = !0, U(o), h("Failed %s type: %s", t, i.message), U(null));
          }
      }
    }
    var Ze = Array.isArray;
    function K(e) {
      return Ze(e);
    }
    function He(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t;
      }
    }
    function Ke(e) {
      try {
        return he(e), !1;
      } catch {
        return !0;
      }
    }
    function he(e) {
      return "" + e;
    }
    function pe(e) {
      if (Ke(e))
        return h("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", He(e)), he(e);
    }
    var M = k.ReactCurrentOwner, Je = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, ge, J;
    J = {};
    function qe(e) {
      if (F.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function ze(e) {
      if (F.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function Ge(e, r) {
      if (typeof e.ref == "string" && M.current && r && M.current.stateNode !== r) {
        var t = R(M.current.type);
        J[t] || (h('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', R(M.current.type), e.ref), J[t] = !0);
      }
    }
    function Xe(e, r) {
      {
        var t = function() {
          me || (me = !0, h("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: t,
          configurable: !0
        });
      }
    }
    function Qe(e, r) {
      {
        var t = function() {
          ge || (ge = !0, h("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: t,
          configurable: !0
        });
      }
    }
    var er = function(e, r, t, n, o, l, s) {
      var i = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: v,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: t,
        props: s,
        // Record the component responsible for creating this element.
        _owner: l
      };
      return i._store = {}, Object.defineProperty(i._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(i, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: n
      }), Object.defineProperty(i, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: o
      }), Object.freeze && (Object.freeze(i.props), Object.freeze(i)), i;
    };
    function rr(e, r, t, n, o) {
      {
        var l, s = {}, i = null, p = null;
        t !== void 0 && (pe(t), i = "" + t), ze(r) && (pe(r.key), i = "" + r.key), qe(r) && (p = r.ref, Ge(r, o));
        for (l in r)
          F.call(r, l) && !Je.hasOwnProperty(l) && (s[l] = r[l]);
        if (e && e.defaultProps) {
          var c = e.defaultProps;
          for (l in c)
            s[l] === void 0 && (s[l] = c[l]);
        }
        if (i || p) {
          var f = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          i && Xe(s, f), p && Qe(s, f);
        }
        return er(e, i, p, o, n, M.current, s);
      }
    }
    var q = k.ReactCurrentOwner, ye = k.ReactDebugCurrentFrame;
    function D(e) {
      if (e) {
        var r = e._owner, t = Y(e.type, e._source, r ? r.type : null);
        ye.setExtraStackFrame(t);
      } else
        ye.setExtraStackFrame(null);
    }
    var z;
    z = !1;
    function G(e) {
      return typeof e == "object" && e !== null && e.$$typeof === v;
    }
    function be() {
      {
        if (q.current) {
          var e = R(q.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function tr(e) {
      return "";
    }
    var Ce = {};
    function nr(e) {
      {
        var r = be();
        if (!r) {
          var t = typeof e == "string" ? e : e.displayName || e.name;
          t && (r = `

Check the top-level render call using <` + t + ">.");
        }
        return r;
      }
    }
    function xe(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var t = nr(r);
        if (Ce[t])
          return;
        Ce[t] = !0;
        var n = "";
        e && e._owner && e._owner !== q.current && (n = " It was passed a child from " + R(e._owner.type) + "."), D(e), h('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, n), D(null);
      }
    }
    function we(e, r) {
      {
        if (typeof e != "object")
          return;
        if (K(e))
          for (var t = 0; t < e.length; t++) {
            var n = e[t];
            G(n) && xe(n, r);
          }
        else if (G(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var o = Pe(e);
          if (typeof o == "function" && o !== e.entries)
            for (var l = o.call(e), s; !(s = l.next()).done; )
              G(s.value) && xe(s.value, r);
        }
      }
    }
    function ar(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t;
        if (typeof r == "function")
          t = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === _))
          t = r.propTypes;
        else
          return;
        if (t) {
          var n = R(r);
          Be(t, e.props, "prop", n, e);
        } else if (r.PropTypes !== void 0 && !z) {
          z = !0;
          var o = R(r);
          h("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", o || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && h("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ir(e) {
      {
        for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
          var n = r[t];
          if (n !== "children" && n !== "key") {
            D(e), h("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", n), D(null);
            break;
          }
        }
        e.ref !== null && (D(e), h("Invalid attribute `ref` supplied to `React.Fragment`."), D(null));
      }
    }
    var Ee = {};
    function Re(e, r, t, n, o, l) {
      {
        var s = Ie(e);
        if (!s) {
          var i = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (i += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var p = tr();
          p ? i += p : i += be();
          var c;
          e === null ? c = "null" : K(e) ? c = "array" : e !== void 0 && e.$$typeof === v ? (c = "<" + (R(e.type) || "Unknown") + " />", i = " Did you accidentally export a JSX literal instead of a component?") : c = typeof e, h("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", c, i);
        }
        var f = rr(e, r, t, o, l);
        if (f == null)
          return f;
        if (s) {
          var C = r.children;
          if (C !== void 0)
            if (n)
              if (K(C)) {
                for (var N = 0; N < C.length; N++)
                  we(C[N], e);
                Object.freeze && Object.freeze(C);
              } else
                h("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              we(C, e);
        }
        if (F.call(r, "key")) {
          var P = R(e), m = Object.keys(r).filter(function(fr) {
            return fr !== "key";
          }), X = m.length > 0 ? "{key: someKey, " + m.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ee[P + X]) {
            var cr = m.length > 0 ? "{" + m.join(": ..., ") + ": ...}" : "{}";
            h(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, X, P, cr, P), Ee[P + X] = !0;
          }
        }
        return e === u ? ir(f) : ar(f), f;
      }
    }
    function sr(e, r, t) {
      return Re(e, r, t, !0);
    }
    function or(e, r, t) {
      return Re(e, r, t, !1);
    }
    var lr = or, ur = sr;
    $.Fragment = u, $.jsx = lr, $.jsxs = ur;
  }()), $;
}
process.env.NODE_ENV === "production" ? Q.exports = hr() : Q.exports = pr();
var a = Q.exports;
const gr = ({
  primary: g = !1,
  size: v = "medium",
  backgroundColor: w,
  label: u,
  ...x
}) => /* @__PURE__ */ a.jsx(
  "button",
  {
    type: "button",
    className: "flex flex-row bg-slate-500 rounded-md p-3 text-white w-full hover:bg-slate-300 transition-all duration-500",
    ...x,
    children: u
  }
), yr = () => {
  const g = {
    sunday: {
      closed: !1,
      startTime: "12:00",
      endTime: "18:00"
    },
    monday: {
      closed: !1,
      startTime: "10:00",
      endTime: "19:00"
    },
    tuesday: {
      closed: !1,
      startTime: "10:00",
      endTime: "19:00"
    },
    wednesday: {
      closed: !1,
      startTime: "10:00",
      endTime: "19:00"
    },
    thursday: {
      closed: !1,
      startTime: "10:00",
      endTime: "19:00"
    },
    friday: {
      closed: !1,
      startTime: "10:00",
      endTime: "19:00"
    },
    saturday: {
      closed: !1,
      startTime: "10:00",
      endTime: "19:00"
    }
  }, v = () => {
    const w = (/* @__PURE__ */ new Date()).getDay(), u = Object.keys(g)[w];
    return g[u].closed ? "Closed" : `${u.charAt(0).toUpperCase()}${u.slice(1)}: ${g[u].startTime} - ${g[u].endTime}`;
  };
  return /* @__PURE__ */ a.jsxs("div", { className: "flex flex-row justify-between", children: [
    /* @__PURE__ */ a.jsx("div", { children: /* @__PURE__ */ a.jsxs("div", { className: "flex gap-4", children: [
      /* @__PURE__ */ a.jsxs("div", { className: "flex gap-1", children: [
        /* @__PURE__ */ a.jsx(
          "svg",
          {
            className: "fill-slate-300",
            width: "12",
            height: "16",
            viewBox: "0 0 12 16",
            xmlns: "http://www.w3.org/2000/svg",
            children: /* @__PURE__ */ a.jsx(
              "path",
              {
                d: "M4.59375 13.8206C3.17188 12.0432 0 7.80493 0 5.39868C0 2.50024 2.32422 0.148682 5.25 0.148682C8.14844 0.148682 10.5 2.50024 10.5 5.39868C10.5 7.80493 7.30078 12.0432 5.87891 13.8206C5.55078 14.2307 4.92188 14.2307 4.59375 13.8206ZM5.25 7.14868C6.20703 7.14868 7 6.38306 7 5.39868C7 4.44165 6.20703 3.64868 5.25 3.64868C4.26562 3.64868 3.5 4.44165 3.5 5.39868C3.5 6.38306 4.26562 7.14868 5.25 7.14868Z",
                fill: "white"
              }
            )
          }
        ),
        /* @__PURE__ */ a.jsx("div", { children: /* @__PURE__ */ a.jsx("p", { className: "text-base/none", children: "132b Horns Road, Ilford, IG2 6BL" }) })
      ] }),
      /* @__PURE__ */ a.jsxs("div", { className: "flex gap-1", children: [
        /* @__PURE__ */ a.jsx(
          "svg",
          {
            className: "fill-slate-300",
            width: "12",
            height: "16",
            viewBox: "0 0 12 16",
            xmlns: "http://www.w3.org/2000/svg",
            children: /* @__PURE__ */ a.jsx(
              "path",
              {
                d: "M4.59375 13.8206C3.17188 12.0432 0 7.80493 0 5.39868C0 2.50024 2.32422 0.148682 5.25 0.148682C8.14844 0.148682 10.5 2.50024 10.5 5.39868C10.5 7.80493 7.30078 12.0432 5.87891 13.8206C5.55078 14.2307 4.92188 14.2307 4.59375 13.8206ZM5.25 7.14868C6.20703 7.14868 7 6.38306 7 5.39868C7 4.44165 6.20703 3.64868 5.25 3.64868C4.26562 3.64868 3.5 4.44165 3.5 5.39868C3.5 6.38306 4.26562 7.14868 5.25 7.14868Z",
                fill: "white"
              }
            )
          }
        ),
        /* @__PURE__ */ a.jsx("div", { children: /* @__PURE__ */ a.jsx("p", { className: "text-base/none", children: "67 Plashet Road, London, E13 0QA" }) })
      ] })
    ] }) }),
    /* @__PURE__ */ a.jsxs("div", { className: "flex flex-row content-start", children: [
      /* @__PURE__ */ a.jsx("div", { className: "flex flex-row content-start mr-2", children: /* @__PURE__ */ a.jsxs("div", { className: "flex gap-1", children: [
        /* @__PURE__ */ a.jsx(
          "svg",
          {
            className: "fill-slate-300 self-center",
            width: "15",
            height: "16",
            viewBox: "0 0 15 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /* @__PURE__ */ a.jsx(
              "path",
              {
                d: "M7 14.7947C3.11719 14.7947 0 11.6775 0 7.79468C0 3.93921 3.11719 0.794678 7 0.794678C10.8555 0.794678 14 3.93921 14 7.79468C14 11.6775 10.8555 14.7947 7 14.7947ZM6.34375 7.79468C6.34375 8.01343 6.45312 8.23218 6.61719 8.34155L9.24219 10.0916C9.54297 10.3103 9.95312 10.2283 10.1445 9.92749C10.3633 9.62671 10.2812 9.21655 9.98047 8.9978L7.65625 7.46655V4.07593C7.65625 3.72046 7.35547 3.41968 6.97266 3.41968C6.61719 3.41968 6.31641 3.72046 6.31641 4.07593L6.34375 7.79468Z",
                fill: "white"
              }
            )
          }
        ),
        /* @__PURE__ */ a.jsx("div", { children: /* @__PURE__ */ a.jsx("p", { className: "text-base/none", children: v() }) })
      ] }) }),
      /* @__PURE__ */ a.jsxs("div", { className: "flex flex-row content-start pl-2 border-l-2 border-white gap-2", children: [
        /* @__PURE__ */ a.jsx(
          "a",
          {
            className: "self-center",
            href: "https://www.facebook.com/firstcarephysiosportsclinic",
            children: /* @__PURE__ */ a.jsx(
              "svg",
              {
                className: "fill-slate-300",
                width: "9",
                height: "16",
                viewBox: "0 0 9 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /* @__PURE__ */ a.jsx(
                  "path",
                  {
                    d: "M8.17383 8.71118H5.97656V15.2737H3.04688V8.71118H0.644531V6.01587H3.04688V3.93579C3.04688 1.59204 4.45312 0.273682 6.5918 0.273682C7.61719 0.273682 8.70117 0.47876 8.70117 0.47876V2.79321H7.5C6.32812 2.79321 5.97656 3.49634 5.97656 4.25806V6.01587H8.58398L8.17383 8.71118Z",
                    fill: "white"
                  }
                )
              }
            )
          }
        ),
        /* @__PURE__ */ a.jsx(
          "a",
          {
            className: "self-center",
            href: "https://www.instagram.com/firstcarephysiosportsclinic",
            children: /* @__PURE__ */ a.jsx(
              "svg",
              {
                className: "fill-slate-300 self-center",
                width: "15",
                height: "14",
                viewBox: "0 0 15 14",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /* @__PURE__ */ a.jsx(
                  "path",
                  {
                    d: "M7.5625 3.40454C9.4082 3.40454 10.9316 4.92798 10.9316 6.77368C10.9316 8.64868 9.4082 10.1428 7.5625 10.1428C5.6875 10.1428 4.19336 8.64868 4.19336 6.77368C4.19336 4.92798 5.6875 3.40454 7.5625 3.40454ZM7.5625 8.97095C8.76367 8.97095 9.73047 8.00415 9.73047 6.77368C9.73047 5.57251 8.76367 4.60571 7.5625 4.60571C6.33203 4.60571 5.36523 5.57251 5.36523 6.77368C5.36523 8.00415 6.36133 8.97095 7.5625 8.97095ZM11.8398 3.28735C11.8398 2.8479 11.4883 2.49634 11.0488 2.49634C10.6094 2.49634 10.2578 2.8479 10.2578 3.28735C10.2578 3.72681 10.6094 4.07837 11.0488 4.07837C11.4883 4.07837 11.8398 3.72681 11.8398 3.28735ZM14.0664 4.07837C14.125 5.16235 14.125 8.41431 14.0664 9.49829C14.0078 10.553 13.7734 11.4612 13.0117 12.2522C12.25 13.0139 11.3125 13.2483 10.2578 13.3069C9.17383 13.3655 5.92188 13.3655 4.83789 13.3069C3.7832 13.2483 2.875 13.0139 2.08398 12.2522C1.32227 11.4612 1.08789 10.553 1.0293 9.49829C0.970703 8.41431 0.970703 5.16235 1.0293 4.07837C1.08789 3.02368 1.32227 2.08618 2.08398 1.32446C2.875 0.562744 3.7832 0.328369 4.83789 0.269775C5.92188 0.211182 9.17383 0.211182 10.2578 0.269775C11.3125 0.328369 12.25 0.562744 13.0117 1.32446C13.7734 2.08618 14.0078 3.02368 14.0664 4.07837ZM12.6602 10.6409C13.0117 9.79126 12.9238 7.74048 12.9238 6.77368C12.9238 5.83618 13.0117 3.7854 12.6602 2.90649C12.4258 2.34985 11.9863 1.8811 11.4297 1.67603C10.5508 1.32446 8.5 1.41235 7.5625 1.41235C6.5957 1.41235 4.54492 1.32446 3.69531 1.67603C3.10938 1.9104 2.66992 2.34985 2.43555 2.90649C2.08398 3.7854 2.17188 5.83618 2.17188 6.77368C2.17188 7.74048 2.08398 9.79126 2.43555 10.6409C2.66992 11.2268 3.10938 11.6663 3.69531 11.9006C4.54492 12.2522 6.5957 12.1643 7.5625 12.1643C8.5 12.1643 10.5508 12.2522 11.4297 11.9006C11.9863 11.6663 12.4551 11.2268 12.6602 10.6409Z",
                    fill: "white"
                  }
                )
              }
            )
          }
        )
      ] })
    ] })
  ] });
}, br = ({ image: g, content: v, header: w, footerLink: u }) => {
  const x = () => typeof v == "string" ? /* @__PURE__ */ a.jsx("p", { children: v }) : /* @__PURE__ */ a.jsx("div", { children: v });
  return /* @__PURE__ */ a.jsxs("div", { className: "rounded-md overflow-hidden shadow-lg", children: [
    g,
    /* @__PURE__ */ a.jsxs("div", { className: "px-6 py-4", children: [
      w && /* @__PURE__ */ a.jsx("div", { className: "font-bold text-xl mb-2", children: "The Coldest Sunset" }),
      x()
    ] }),
    u && /* @__PURE__ */ a.jsx("div", { className: "px-6 pt-0 pb-3", children: /* @__PURE__ */ a.jsx(
      "a",
      {
        className: "inline-block bg-gray-200 hover:bg-primary hover:text-white rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2 no-underline transition-all duration-300",
        href: u.url,
        children: u.urlText ?? u.url
      }
    ) })
  ] });
}, Cr = ({
  children: g,
  isOpen: v = !1,
  hasCloseBtn: w = !0,
  onClose: u
}) => {
  const [x, T] = dr(v), j = vr(null);
  _e(() => {
    const b = j.current;
    b && (x ? b.showModal() : b.close());
  }, [x]), _e(() => {
    T(v);
  }, [v]);
  const E = () => {
    u && u(), T(!1);
  }, d = (b) => {
    b.key === "Escape" && E();
  };
  return /* @__PURE__ */ a.jsxs(
    "dialog",
    {
      className: "bg-white rounded-lg shadow-lg border-none relative p-8 backdrop:bg-black/30 duration-900",
      ref: j,
      onKeyDown: d,
      children: [
        w && /* @__PURE__ */ a.jsx("button", { className: "text-right", onClick: E, children: /* @__PURE__ */ a.jsx(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 384 512",
            height: 20,
            width: 20,
            children: /* @__PURE__ */ a.jsx(
              "path",
              {
                fill: "black",
                d: "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
              }
            )
          }
        ) }),
        g
      ]
    }
  );
}, xr = {
  fontFamily: {
    jost: ["Satisfy", "cursive"]
  },
  extend: {
    colors: {
      primary: {
        DEFAULT: "#426D24"
      },
      secondary: {
        DEFAULT: "#665247"
      }
    }
  }
};
export {
  gr as Button,
  br as Card,
  Cr as Modal,
  yr as SocialNav,
  xr as libTheme
};
